import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormStateEnum } from '@magieno/angular-advanced-forms';
import { merge, Subscription } from 'rxjs';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';
import {
  RolloverPropertyTransferredSection84_1Options,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred-section-84_1.options';
import {
  RolloverPropertyTypeEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/rollover/rollover-property-type.enum';
import {
  RolloverPropertyRevenueTypeEnum,
} from '../../../../../../../../../../../common/src/enums/calculations/rollover/rollover-property-revenue-type.enum';
import {
  RolloverPropertySection84_1FormComponent,
} from '../rollover-property-section-84_1-form/rollover-property-section-84_1-form.component';
import {AdvancedFormGroup} from "@magieno/angular-advanced-forms";
import { AdvancedFormControl } from "@magieno/angular-advanced-forms";
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import { Locale } from '@magieno/common';
import { CurrencyEnum } from '@magieno/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rollover-property-form',
  templateUrl: './rollover-property-form.component.html',
  styleUrls: ['./rollover-property-form.component.scss'],
  standalone: false,
})
export class RolloverPropertyFormComponent implements OnInit, OnDestroy {

  rolloverPropertyTypeEnum = RolloverPropertyTypeEnum;

  onPropertyTypeChangeSubscription: Subscription;
  onAreSharesChangeSubscription: Subscription;
  onIsVerifyPropertyEligibilityChangeSubscription: Subscription;
  onIsRealEstateChangeSubscription: Subscription;
  onIsErrorNotAdmissiblePropertySubscription: Subscription;
  onIsDepreciablePropertyTheLastOfItsCategorySubscription: Subscription;

  @Input()
  propertyForm: AdvancedFormGroup<RolloverPropertyTransferredOptions>;

  @Input()
  form: AdvancedForm<RolloverOptions>;

  @Input()
  index: number;

  @ViewChild('section841')
  section84_1Component: RolloverPropertySection84_1FormComponent;

  isSectionSharesCollapsed: boolean = false;
  isSectionSharesApplicable: boolean;
  isSectionDepreciablePropertyCollapsed: boolean = false;
  isSectionDepreciablePropertyApplicable: boolean;


  isErrorNotAdmissibleProperty: boolean;

  areSharesVisible: boolean;
  isBusinessIncomeVisible: boolean;

  constructor(private readonly translateService: TranslateService,
              private readonly changeDetectorRef: ChangeDetectorRef) {

  }

  get currency(): CurrencyEnum {
    return CurrencyEnum.CAD;
  }

  get locale(): Locale {
    switch (this.translateService.currentLang) {
      case 'fr':
        return Locale.fr_CA;
      case 'en':
        return Locale.en_CA;
    }

    return Locale.fr_CA;
  }

  get adjustedCostBase(): AdvancedFormControl<number, number, number> {
    return this.propertyForm.formElements.adjustedCostBase as AdvancedFormControl<number, number, number>;
  }

  get agreedAmount(): AdvancedFormControl<number, number, number> {
    return this.propertyForm.formElements.agreedAmount as AdvancedFormControl<number, number, number>;
  }

  get areShares(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.areShares as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isBusinessIncome(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isBusinessIncome as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get fairMarketValue(): AdvancedFormControl<number, number, number> {
    return this.propertyForm.formElements.fairMarketValue as AdvancedFormControl<number, number, number>;
  }

  get isArticle22(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isArticle22 as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isCashAccounting(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isCashAccounting as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isCustomerAccount(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isCustomerAccount as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isDepreciablePropertyTheLastOfItsCategory(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isDepreciablePropertyTheLastOfItsCategory as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isDoPerfectRollover(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isDoPerfectRollover as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isInternalRollOver(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isInternalRollOver as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isNonResident(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isNonResident as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isRealEstate(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isRealEstate as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isSameSharesConditions(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isSameSharesConditions as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get isVerifyPropertyEligibility(): AdvancedFormControl<boolean, boolean, boolean> {
    return this.propertyForm.formElements.isVerifyPropertyEligibility as AdvancedFormControl<boolean, boolean, boolean>;
  }

  get paidUpCapitalOfTransferredShares(): AdvancedFormControl<number, number, number> {
    return this.propertyForm.formElements.paidUpCapitalOfTransferredShares as AdvancedFormControl<number, number, number>;
  }

  get propertyType(): AdvancedFormControl<RolloverPropertyTypeEnum, RolloverPropertyTypeEnum, RolloverPropertyTypeEnum> {
    return this.propertyForm.formElements.propertyType as AdvancedFormControl<RolloverPropertyTypeEnum, RolloverPropertyTypeEnum, RolloverPropertyTypeEnum>;
  }

  get propertyRevenueType(): AdvancedFormControl<RolloverPropertyRevenueTypeEnum, RolloverPropertyRevenueTypeEnum, RolloverPropertyRevenueTypeEnum> {
    return this.propertyForm.formElements.propertyRevenueType as AdvancedFormControl<RolloverPropertyRevenueTypeEnum, RolloverPropertyRevenueTypeEnum, RolloverPropertyRevenueTypeEnum>;
  }

  get section84_1(): AdvancedFormGroup<RolloverPropertyTransferredSection84_1Options> {
    return this.propertyForm.formElements.section84_1 as AdvancedFormGroup<RolloverPropertyTransferredSection84_1Options>;
  }

  get title(): AdvancedFormControl<string, string, string> {
    return this.propertyForm.formElements.title as AdvancedFormControl<string, string, string>;
  }

  get underpreciatedCapitalCostAfterAdditionsAndDispositions(): AdvancedFormControl<number, number, number> {
    return this.propertyForm.formElements.underpreciatedCapitalCostAfterAdditionsAndDispositions as AdvancedFormControl<number, number, number>;
  }

  ngOnInit(): void {
    // this.refresh();
    this.onPropertyTypeChangeSubscription = this.propertyType.value$.subscribe((value) => {
      this.handleAreSharesVisibility();
      this.handleSectionDepreciablePropertyVisibility();
      this.handleIsBusinessIncomeVisibility();
      this.changeDetectorRef.detectChanges();
    });
    this.onAreSharesChangeSubscription = this.areShares.value$.subscribe((value) => {
      this.handleSectionSharesVisibility();
      this.changeDetectorRef.detectChanges();
    });

    this.onIsVerifyPropertyEligibilityChangeSubscription = this.isVerifyPropertyEligibility.value$.subscribe((value) => {
      this.handleVerifyPropertyEligibilityVisibility();
      this.changeDetectorRef.detectChanges();
    });

    this.onIsRealEstateChangeSubscription = this.isRealEstate.value$.subscribe((value) => {
      this.handleIsNonResidentVisibility();
      this.changeDetectorRef.detectChanges();
    });

    this.onIsErrorNotAdmissiblePropertySubscription = merge(
      this.propertyType.value$,
      this.isRealEstate.value$,
      this.isNonResident.value$,
      this.isCustomerAccount.value$,
      this.isArticle22.value$,
      this.isCashAccounting.value$,
    ).subscribe((value) => {
      this.handleIsErrorNotAdmissibleProperty();
      this.changeDetectorRef.detectChanges();
    });
  }

  ngAfterViewInit() {
    this.refresh();
  }

  ngOnDestroy() {
    this.onPropertyTypeChangeSubscription?.unsubscribe();
    this.onAreSharesChangeSubscription?.unsubscribe();
    this.onIsVerifyPropertyEligibilityChangeSubscription?.unsubscribe();
    this.onIsRealEstateChangeSubscription?.unsubscribe();
    this.onIsErrorNotAdmissiblePropertySubscription?.unsubscribe();
    this.onIsDepreciablePropertyTheLastOfItsCategorySubscription?.unsubscribe();
  }

  refresh() {
    this.handleAreSharesVisibility();
    this.handleSectionSharesVisibility();
    this.handleSectionDepreciablePropertyVisibility();
    this.handleIsErrorNotAdmissibleProperty();
    this.handleIsNonResidentVisibility();
    this.handleVerifyPropertyEligibilityVisibility();

    this.changeDetectorRef.detectChanges();
  }

  handleAreSharesVisibility() {
    if (this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.nonDepreciableProperty) {
      this.enableAreShares();
    } else {
      this.disableAreShares();
    }
  }

  disableAreShares() {
    this.areSharesVisible = false;
    this.areShares.disable();
    this.areShares.setValue(undefined);
    this.areShares.state = FormStateEnum.Valid;
  }

  enableAreShares() {
    this.areSharesVisible = true;
    this.areShares.enable();
  }

  handleIsBusinessIncomeVisibility() {
    if (this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.mineralAsset ||
      this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.debtObligations ||
      this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.specificDebtObligations ||
      this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.agriInvestment) {
      this.enableIsBusinessIncome();
    } else {
      this.disableIsBusinessIncome();
    }
  }

  disableIsBusinessIncome() {
    this.isBusinessIncomeVisible = false;
    this.isBusinessIncome.disable();
    this.isBusinessIncome.setValue(undefined);
    this.isBusinessIncome.state = FormStateEnum.Valid;
  }

  enableIsBusinessIncome() {
    this.isBusinessIncomeVisible = true;
    this.isBusinessIncome.enable();
  }

  handleSectionSharesVisibility() {
    if (this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.nonDepreciableProperty &&
      this.propertyForm.value.areShares === true) {
      this.isSectionSharesApplicable = true;
      this.enableSectionShares();
    } else {
      this.isSectionSharesApplicable = false;
      this.disableSectionShares();
    }
  }

  disableSectionShares() {
    this.isSectionSharesCollapsed = true;

    this.paidUpCapitalOfTransferredShares.disable();
    this.paidUpCapitalOfTransferredShares.setValue(undefined);
    this.paidUpCapitalOfTransferredShares.state = FormStateEnum.Valid;
    this.isInternalRollOver.disable();
    this.isInternalRollOver.setValue(undefined);
    this.isInternalRollOver.state = FormStateEnum.Valid;
    this.isSameSharesConditions.disable();
    this.isSameSharesConditions.setValue(undefined);
    this.isSameSharesConditions.state = FormStateEnum.Valid;

    this.section84_1Component.disableAll();
  }

  enableSectionShares() {
    this.isSectionSharesCollapsed = false;
    this.paidUpCapitalOfTransferredShares.enable();
    this.isInternalRollOver.enable();
    this.isSameSharesConditions.enable();

    this.section84_1Component.enableAll();
  }

  handleSectionDepreciablePropertyVisibility() {
    if (this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.depreciableProperty) {
      this.isSectionDepreciablePropertyApplicable = true;
      this.enableSectionDepreciableProperty();
    } else {
      this.isSectionDepreciablePropertyApplicable = false;
      this.disableSectionDepreciableProperty();
    }
  }

  disableSectionDepreciableProperty() {
    this.isSectionDepreciablePropertyCollapsed = true;

    this.underpreciatedCapitalCostAfterAdditionsAndDispositions.disable();
    this.underpreciatedCapitalCostAfterAdditionsAndDispositions.setValue(undefined);
    this.underpreciatedCapitalCostAfterAdditionsAndDispositions.state = FormStateEnum.Valid;
    this.isDepreciablePropertyTheLastOfItsCategory.disable();
    this.isDepreciablePropertyTheLastOfItsCategory.setValue(undefined);
    this.isDepreciablePropertyTheLastOfItsCategory.state = FormStateEnum.Valid;
    this.propertyRevenueType.disable();
    this.propertyRevenueType.setValue(undefined);
    this.propertyRevenueType.state = FormStateEnum.Valid;
  }

  enableSectionDepreciableProperty() {
    this.isSectionDepreciablePropertyCollapsed = false;

    this.underpreciatedCapitalCostAfterAdditionsAndDispositions.enable();
    this.isDepreciablePropertyTheLastOfItsCategory.enable();
    this.propertyRevenueType.enable();
  }

  handleIsErrorNotAdmissibleProperty() {
    if ((this.propertyForm.value.isRealEstate === true && this.propertyForm.value.propertyType === RolloverPropertyTypeEnum.inventoryProperty)
      || this.propertyForm.value.isNonResident === true
      || this.propertyForm.value.isCashAccounting === true
      || this.propertyForm.value.isArticle22 === true) {
      this.isErrorNotAdmissibleProperty = true;
    } else {
      this.isErrorNotAdmissibleProperty = false;
    }
  }

  handleIsNonResidentVisibility() {
    if (this.propertyForm.value.isRealEstate === true && this.propertyForm.value.propertyType !== RolloverPropertyTypeEnum.inventoryProperty) {
      this.enableIsNonResident();
    } else {
      this.disableIsNonResident();
    }
  }

  disableIsNonResident() {
    this.isNonResident.disable();
    this.isNonResident.setValue(undefined);
    this.isNonResident.state = FormStateEnum.Valid;
  }

  enableIsNonResident() {
    this.isNonResident.enable();
  }

  handleVerifyPropertyEligibilityVisibility() {
    if (this.propertyForm.value.isVerifyPropertyEligibility === true) {
      this.enableVerifyPropertyEligibility();
    } else {
      this.disableVerifyPropertyEligibility();
    }
  }

  disableVerifyPropertyEligibility() {
    this.isRealEstate.disable();
    this.isRealEstate.setValue(undefined);
    this.isRealEstate.state = FormStateEnum.Valid;

    this.disableIsNonResident();

    this.isCustomerAccount.disable();
    this.isCustomerAccount.setValue(undefined);
    this.isCustomerAccount.state = FormStateEnum.Valid;
    this.isArticle22.disable();
    this.isArticle22.setValue(undefined);
    this.isArticle22.state = FormStateEnum.Valid;
    this.isCashAccounting.disable();
    this.isCashAccounting.setValue(undefined);
    this.isCashAccounting.state = FormStateEnum.Valid;
  }

  enableVerifyPropertyEligibility() {
    this.isRealEstate.enable();

    this.enableIsNonResident();

    this.isCustomerAccount.enable();
    this.isArticle22.enable();
    this.isCashAccounting.enable();

  }
}
